import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { Airplane, Gauge, FilePlus, SignOut, UploadSimple, ChartLine, Snowflake, GraduationCap, Student } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    toast.success("Oturum sonlandırıldı.");
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col border-r border-slate-200 bg-white">
        <Link to="/admin" className="px-6 py-5 border-b border-slate-200 flex items-center gap-3">
          <div className="h-9 w-9 bg-[#0B2046] flex items-center justify-center">
            <Airplane size={18} weight="fill" className="text-white -rotate-45" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-black tracking-tighter text-[15px] text-slate-900">IAVA</div>
            <div className="label-eyebrow text-[9px]">Yönetici Konsolu</div>
          </div>
        </Link>

        <nav className="flex-1 px-3 py-5 space-y-1">
          <SideLink to="/admin" end icon={<Gauge size={16} />} label="Sertifika Kaydı" testid="nav-registry" />
          <SideLink to="/admin/issue" icon={<FilePlus size={16} />} label="Sertifika Oluştur" testid="nav-issue" />
          <SideLink to="/admin/programs" icon={<GraduationCap size={16} />} label="Eğitim Programları" testid="nav-programs" />
          <SideLink to="/admin/transcripts" icon={<Student size={16} />} label="Öğrenci Transkriptleri" testid="nav-transcripts" />
          <SideLink to="/admin/bulk" icon={<UploadSimple size={16} />} label="Toplu İçe Aktar" testid="nav-bulk" />
          <SideLink to="/admin/logs" icon={<ChartLine size={16} />} label="Doğrulama Kayıtları" testid="nav-logs" />
          <SideLink to="/admin/revoked" icon={<Snowflake size={16} />} label="İptal Edilenler" testid="nav-revoked" />
        </nav>

        <div className="border-t border-slate-200 p-4">
          <div className="label-eyebrow">Oturum Açık</div>
          <div className="text-sm font-medium text-slate-900 mt-1 truncate">{user?.email}</div>
          <button
            data-testid="admin-logout-button"
            onClick={doLogout}
            className="mt-4 w-full inline-flex items-center justify-center gap-2 px-3 py-2 border border-slate-300 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
          >
            <SignOut size={14} /> Çıkış yap
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <div className="lg:hidden border-b border-slate-200 bg-white px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 bg-[#0B2046] flex items-center justify-center">
              <Airplane size={14} weight="fill" className="text-white -rotate-45" />
            </div>
            <span className="font-display font-black tracking-tighter">IAVA</span>
          </div>
          <button
            onClick={doLogout}
            className="text-xs font-medium text-slate-700"
            data-testid="admin-logout-button-mobile"
          >
            Çıkış yap
          </button>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

function SideLink({ to, end, icon, label, testid }) {
  return (
    <NavLink
      end={end}
      to={to}
      data-testid={testid}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
          isActive
            ? "bg-[#0B2046] text-white"
            : "text-slate-700 hover:bg-slate-100"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}
